
import React from "react"
export function SimpleButton({ label, disabled, className, onClick }: { label: string, disabled?: boolean, className?: string, onClick: () => void }): JSX.Element {
  return <button
    type="button"
    onClick={onClick}
    className={`back-button flex items-center h-10 px-5 pr-0 md:mr-5 w-fit text-cents-black`.concat(className ? ` ${className}` : '').concat(disabled ? ' opacity-25' : '')}
    disabled={disabled}
  >
    <span className="mr-1">
      {label}
    </span>
  </button>
}